import ContactForm from "../components/ContactForm";
import PageHeader from "../components/PageHeader";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaClock,
} from "react-icons/fa";
import { Helmet } from "react-helmet-async";
import contactImg from "../assets/images/aboutUs.jpg";

export default function ContactUs() {
  const brand =
    "from-blue-600 via-cyan-500 to-blue-700 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900";

  return (
    <>
      <Helmet>
        {/* Basic SEO */}
        <title>Contact Us | UAE Dubai Hotels</title>

        <meta
          name="description"
          content="Contact UAE Dubai Hotels for hotel booking assistance, reservation support, partnership inquiries, and customer service. We're here to help you find the perfect hotel across Dubai and the UAE."
        />

        <meta
          name="keywords"
          content="Contact UAE Dubai Hotels, hotel booking support Dubai, UAE hotel reservations, customer service UAE hotels, Dubai accommodation, hotel inquiries UAE"
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="UAE Dubai Hotels" />

        {/* Canonical */}
        <link
          rel="canonical"
          href="https://uaedubaihotels.com/contact-us"
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="UAE Dubai Hotels" />
        <meta property="og:locale" content="en_US" />

        <meta
          property="og:title"
          content="Contact Us | UAE Dubai Hotels"
        />

        <meta
          property="og:description"
          content="Get in touch with UAE Dubai Hotels for hotel reservations, customer support, partnership opportunities, and travel-related inquiries across Dubai and the UAE."
        />

        <meta
          property="og:url"
          content="https://uaedubaihotels.com/contact-us"
        />

        <meta
          property="og:image"
          content="https://uaedubaihotels.com/images/default-og.png"
        />

        {/* Twitter */}
        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content="Contact Us | UAE Dubai Hotels"
        />

        <meta
          name="twitter:description"
          content="Contact UAE Dubai Hotels for booking assistance, customer support, hotel reservations, and inquiries about accommodation across Dubai and the UAE."
        />

        <meta
          name="twitter:image"
          content="https://uaedubaihotels.com/images/default-og.png"
        />
      </Helmet>

      <div className="
w-full
bg-[#FCFAF5]
dark:bg-gray-950
transition
">


        {/* HERO */}

        <section
          className="
relative
h-[380px]
md:h-[420px]
flex
items-center
bg-cover
bg-center
"
          style={{
            backgroundImage:
              `linear-gradient(rgba(0,0,0,.65),rgba(0,0,0,.65)),url(${contactImg})`
          }}
        >


          <div className="
container
mx-auto
px-6
text-white
">


            <p className="
uppercase
tracking-[0.3em]
text-[#D4B76A]
text-sm
mb-5
">
              Contact UAE Discounted Hotels
            </p>



            <h1
              className="
        text-2xl
        sm:text-3xl
        md:text-5xl
        font-serif
        max-w-3xl
        leading-tight
    "
            >
              Let's Create Your
              Perfect UAE Stay
            </h1>



            <p className="
mt-5
max-w-xl
text-white/80
leading-relaxed
">

              Have questions about hotels,
              reservations or exclusive deals?
              Our team is ready to help.

            </p>


          </div>


        </section>








        {/* CONTACT SECTION */}


        <section className="
container
mx-auto
px-6
py-20
grid
lg:grid-cols-3
gap-8
">


          {/* FORM */}



          <div className="
lg:col-span-2
">


            <div className="
bg-white
dark:bg-gray-900
rounded-[35px]
border
border-[#DDD2BA]
shadow-xl
p-6
md:p-10
relative
overflow-hidden
">


              <div className="
absolute
right-0
top-0
w-40
h-40
bg-[#B89442]/10
rounded-full
blur-3xl
"/>



              <h2 className="
text-3xl
font-serif
dark:text-white
relative
">

                Let's Talk 👋

              </h2>


              <p className="
mt-3
text-gray-500
dark:text-gray-400
relative
">

                Send us your enquiry and our team
                will reply as soon as possible.

              </p>



              <div className="
mt-8
relative
">

                <ContactForm />

              </div>



            </div>


          </div>


          {/* INFO */}


          <div className="
space-y-5
">


            {

              [
                {
                  icon: <FaMapMarkerAlt />,
                  title: "Office",
                  value: "Dubai, UAE"
                },

                {
                  icon: <FaPhoneAlt />,
                  title: "Phone",
                  value: "+971 123 456 789"
                },

                {
                  icon: <FaEnvelope />,
                  title: "Email",
                  value: "info@uaediscountedhotels.com"
                },

                {
                  icon: <FaClock />,
                  title: "Support",
                  value: "24/7 Customer Assistance"
                }

              ].map((item, index) => (


                <div

                  key={index}

                  className="
flex
items-center
gap-4
p-5
rounded-[28px]
bg-white
dark:bg-gray-900
border
border-[#DDD2BA]
shadow-sm
hover:shadow-xl
transition
"

                >


                  <div className="
w-14
h-14
rounded-2xl
bg-[#EFE7D5]
text-[#0F766E]
flex
items-center
justify-center
text-lg
">

                    {item.icon}

                  </div>



                  <div>

                    <h3 className="
font-semibold
dark:text-white
">

                      {item.title}

                    </h3>


                    <p className="
text-sm
text-gray-500
dark:text-gray-400
">

                      {item.value}

                    </p>


                  </div>



                </div>



              ))


            }




          </div>
















        </section>









        {/* MAP */}


        <section className="
container
mx-auto
px-6
pb-20
">


          <div className="
rounded-[35px]
overflow-hidden
border
border-[#DDD2BA]
shadow-xl
">


            <iframe

              src="https://www.google.com/maps?q=Dubai&output=embed"

              className="
w-full
h-[400px]
"

              loading="lazy"

            />


          </div>


        </section>








        {/* FAQ */}


        <section className="
bg-white
dark:bg-gray-900
py-20
">


          <div className="
container
mx-auto
px-6
max-w-5xl
">


            <h2 className="
text-4xl
font-serif
text-center
dark:text-white
mb-12
">

              Frequently Asked Questions

            </h2>



            <div className="space-y-4">


              {

                [
                  {
                    q: "How fast do you respond?",
                    a: "Usually within 24 hours."
                  },

                  {
                    q: "Do you help with hotel reservations?",
                    a: "Yes, our team can assist with finding the best hotel deals."
                  },

                  {
                    q: "Is customer support available?",
                    a: "Yes, our support team is available 24/7."
                  }

                ].map((faq, index) => (


                  <details

                    key={index}

                    className="
bg-[#FCFAF5]
dark:bg-gray-800
border
border-[#DDD2BA]
rounded-2xl
p-5
"

                  >


                    <summary className="
cursor-pointer
font-semibold
dark:text-white
">

                      {faq.q}

                    </summary>


                    <p className="
mt-3
text-gray-500
dark:text-gray-300
">

                      {faq.a}

                    </p>


                  </details>


                ))


              }


            </div>


          </div>


        </section>






        {/* CTA */}


        <section className="
mx-6
my-20
rounded-[40px]
bg-[#111827]
py-16
text-center
px-6
">


          <h2 className="
text-4xl
font-serif
text-white
">

            Ready To Book Your Stay?

          </h2>


          <p className="
mt-5
text-white/70
">

            Explore thousands of hotels
            across UAE today.

          </p>



          <a

            href="/hotels"

            className="
inline-block
mt-8
px-8
py-3
rounded-full
bg-[#B89442]
text-white
font-semibold
hover:bg-[#0F766E]
transition
"

          >

            View Hotels →

          </a>


        </section>





      </div>
    </>
  );
}